import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';

export const useUnlinkAccount = (accountId: string) => {
  const { customerId } = useStore((state) => state.user);

  return useMutation(['useUnlinkAccount', accountId], async () => {
    const { data } = await httpService.delete(`${BASE_URL}/api/v1/user/${customerId}/link/${accountId}`);

    return data;
  });
};
